import { Component, Input } from "@angular/core";
import { BlogService } from "src/app/services/blog.service";

@Component({
  selector: "app-strapi-media",
  templateUrl: "./strapi-media.component.html",
  styleUrls: ["./strapi-media.component.sass"],
})
export class StrapiMediaComponent {
  constructor(private blogService: BlogService) {}

  @Input() data: any;

  getImageUrl(url: string): string {
    return this.blogService.getImageUrl(url);
  }
}
